import { render } from "./Navigation.vue?vue&type=template&id=09d556d8&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=09d556d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Alexa\\OneDrive\\Bureau\\infolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d556d8"]])

export default __exports__